import { Component, OnDestroy, OnInit } from "@angular/core";
import { DataService } from "../../../_services/data.service";
import { AuthenticationService } from "../../../_services/authentication.service";
import {
  EventsService,
  ParentEventSearchState,
} from "../../../_services/eventsServices/events.service";
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { ParentEventFromSearch } from "../event-page-models/parent-event-from-search";
import { RowEventEmit } from "../event-page-models/row-event-emit";
import { Router } from "@angular/router";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { ParentEventsPageMainModalContainerComponent } from "../parent-events-page-main-modal-container/parent-events-page-main-modal-container.component";
import { sleep } from "../../../_helpers/sleep";
import { GenericModalComponent } from "../../../form/generic-app-modal/generic-modal.component";
import { EventFormCustomFormType } from "../event-page-models/event-form-custom-form-type";
import { EventFormEventType } from "../event-page-models/event-form-event-type";
import { SpecificEventTypeOptions } from "./parent-event-type-options/parent-event-type-options";
import { SessionManagerService } from "../../../_services/SessionManager/session-manager.service";

@Component({
  selector: "parent-events-page",
  templateUrl: "./parent-events-page.component.html",
  styleUrls: ["./parent-events-page.component.scss"],
})
export class ParentEventsPageComponent implements OnInit, OnDestroy {
  public showMichlolOptions: boolean = true;
  public isMock: boolean = true;
  public readonly $parentEvents: BehaviorSubject<ParentEventFromSearch[]> =
    new BehaviorSubject<ParentEventFromSearch[]>([]);
  public readonly $openParentEventView: BehaviorSubject<string> =
    new BehaviorSubject<string>("");
  public readonly $parentEventsSearchState: BehaviorSubject<ParentEventSearchState> =
    new BehaviorSubject<ParentEventSearchState>(null);
  public readonly $openDeleteModal: BehaviorSubject<
    ParentEventFromSearch | false
  > = new BehaviorSubject<ParentEventFromSearch | false>(false);
  public scrollCallback: ($event: any) => void;

  constructor(
    private eventsService: EventsService,
    private modalService: NgbModal,
    private router: Router,
    private dataService: DataService,
    private authenticationService: AuthenticationService,
    private sessionManagerService: SessionManagerService
  ) {
    this.isMock = !window.location.href.includes("admin");
    this.getParentEvents();
    this.eventsService.getParentEventsSearchState().subscribe((value) => {
      const firstSearch = !value || !value.previous;
      if (firstSearch || true) {
        this.$openParentEventView.next("");
      }
      this.$parentEventsSearchState.next(value);
    });
    this.scrollCallback = this.scrollCallbackHandler.bind(this);
  }

  public get specificEventTypeOptions() {
    return SpecificEventTypeOptions;
  }
  public get isDevelopmentMode() {
    return this.sessionManagerService.isDevModeActive();
  }
  public ngOnInit(): void {
    this.eventsService.checkIfUserLogged().then();
  }

  public ngOnDestroy(): void {}

  public async rowEventHandler($event: RowEventEmit) {
    switch ($event.action) {
      case "open":
        this.$openParentEventView.next($event.eventId);
        break;
      case "close":
        this.$openParentEventView.next("");
        break;
      case "delete":
        break;
      // const parentEvent = this.$parentEvents.value.find(
      //   (fe) => fe.parentEventCode === $event.eventCode
      // );
      //
      // this.$openDeleteModal.next(parentEvent);
      // break;
      case "duplicate":
        this.cloneEventFromSearchResults($event);
        // const modalRef: NgbModalRef = this.modalService.open(
        //   GenericModalComponent
        // );
        // const text =
        //   $event.action === "duplicate"
        //     ? `האפשרות לשכפול ארוע תתווסף בהמשך`
        //     : `האפשרות מחיקת ארוע תתווסף בהמשך`;
        //
        // modalRef.componentInstance.modalOptions = {
        //   approveOption: "אישור",
        //   cancelOption: "",
        //   modalHeader: "לא קיים",
        //   modalText: text,
        //   onlyApprove: true,
        // };
        // modalRef.result.then((res) => {});

        break;
      case "edit":
        this.editEventFromSearchResults($event);

        break;
    }
  }
  public editEventFromSearchResults(parentEvent: RowEventEmit) {
    if (parentEvent.eventObject.eventType === EventFormEventType.Michlol) {
      const modalRef: NgbModalRef = this.modalService.open(
        ParentEventsPageMainModalContainerComponent,
        ParentEventsPageMainModalContainerComponent.modalOptions
      );
      (
        modalRef.componentInstance as ParentEventsPageMainModalContainerComponent
      ).modalEventIdInput = parentEvent.eventId;
      (
        modalRef.componentInstance as ParentEventsPageMainModalContainerComponent
      ).customEventType = EventFormCustomFormType.Michlol;
      return;
    }

    const modalRefEdit: NgbModalRef = this.modalService.open(
      ParentEventsPageMainModalContainerComponent,
      ParentEventsPageMainModalContainerComponent.modalOptions
    );
    (
      modalRefEdit.componentInstance as ParentEventsPageMainModalContainerComponent
    ).modalEventIdInput = parentEvent.eventId;
    (
      modalRefEdit.componentInstance as ParentEventsPageMainModalContainerComponent
    ).customEventType = EventFormCustomFormType.common;
  }

  public cloneEventFromSearchResults(parentEvent: RowEventEmit) {
    if (parentEvent.eventObject.eventType === EventFormEventType.Michlol) {
      const modalRef: NgbModalRef = this.modalService.open(
        ParentEventsPageMainModalContainerComponent,
        ParentEventsPageMainModalContainerComponent.modalOptions
      );
      (
        modalRef.componentInstance as ParentEventsPageMainModalContainerComponent
      ).modalEventIdInput = parentEvent.eventId;
      (
        modalRef.componentInstance as ParentEventsPageMainModalContainerComponent
      ).customEventType = EventFormCustomFormType.Michlol;
      (
        modalRef.componentInstance as ParentEventsPageMainModalContainerComponent
      ).isConedEvent = true;
      return;
    }

    const modalRefEdit: NgbModalRef = this.modalService.open(
      ParentEventsPageMainModalContainerComponent,
      ParentEventsPageMainModalContainerComponent.modalOptions
    );
    (
      modalRefEdit.componentInstance as ParentEventsPageMainModalContainerComponent
    ).modalEventIdInput = parentEvent.eventId;
    (
      modalRefEdit.componentInstance as ParentEventsPageMainModalContainerComponent
    ).customEventType = EventFormCustomFormType.common;
    (
      modalRefEdit.componentInstance as ParentEventsPageMainModalContainerComponent
    ).isConedEvent = true;
  }

  public modalResultHandler($event: any) {
    if ($event) {
      const parentEvent = this.$parentEvents.value.find(
        (fe) => fe.parentEventCode === $event.parentEventCode
      );
    }
  }

  public scrollCallbackHandler($event: any) {
    this.eventsService.scrolledToBottomOfResults().then();
  }
  public addNewCustomEvent(customEventType: EventFormCustomFormType) {
    const modalRef: NgbModalRef = this.modalService.open(
      ParentEventsPageMainModalContainerComponent,
      ParentEventsPageMainModalContainerComponent.modalOptions
    );
    (
      modalRef.componentInstance as ParentEventsPageMainModalContainerComponent
    ).modalEventIdInput = "new";
    (
      modalRef.componentInstance as ParentEventsPageMainModalContainerComponent
    ).customEventType = customEventType;
  }
  public addNewEvent() {
    const modalRef: NgbModalRef = this.modalService.open(
      ParentEventsPageMainModalContainerComponent,
      ParentEventsPageMainModalContainerComponent.modalOptions
    );
    (
      modalRef.componentInstance as ParentEventsPageMainModalContainerComponent
    ).modalEventIdInput = "new";
    (
      modalRef.componentInstance as ParentEventsPageMainModalContainerComponent
    ).customEventType = EventFormCustomFormType.common;
  }

  public onlyCreateEvent() {
    this.router.navigate([`/create-event-demo/${"new"}`]).then();
  }

  public specificEventTypeHandler($event: RowEventEmit) {
    switch ($event.action as string) {
      case "addMichlol":
        this.addNewCustomEvent(EventFormCustomFormType.Michlol);
        break;
      case "addCommonEvent":
        this.addNewEvent();
        break;
    }
  }

  private getParentEvents(): void {
    this.eventsService
      .getAllParentEvents()
      .subscribe((events: ParentEventFromSearch[]) => {
        this.$parentEvents.next(events);
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/events-screen/parent-events-page/parent-events-page.component.ts